import { Component, OnInit, ViewChild } from '@angular/core';
import { Issue } from "@models/issue.model";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { Router } from "@angular/router";
import { IssuesService } from "@services/issues.service";
import { Reason } from "@models/reason.model";
import { ReasonsService } from "@services/reasons.service";
import { IssueCreateModalComponent } from "@app/roles/admin/pages/issues/components/issue-create-modal/issue-create-modal.component";
import { Log } from "ng2-logger";
import { PermissionService } from "@app/authentication/services/permission.service";
import * as FileSaver from "file-saver";
import { HttpResponse } from "@angular/common/http";

@Component({
    selector: 'app-issues',
    templateUrl: './issues.component.html',
    styleUrls: ['./issues.component.scss']
})
export class IssuesComponent implements OnInit {
    _logger = Log.create(IssuesComponent.name);
    @ViewChild(IssueCreateModalComponent, {static: true}) issueModal: IssueCreateModalComponent;

    issues: Issue[] = [];
    reasons: Reason[] = [];
    tableConfig = new TableConfig();
    isLoadingIssues = false;
    isLoadingRoles = false;

    constructor(private issuesService: IssuesService,
                private reasonsService: ReasonsService,
                private router: Router,
                private permissionService: PermissionService) {
    }

    ngOnInit() {
        this.getIssues(this.tableConfig);
        if (this.shouldRenderModifiers()) {
            this.getReasons();
        }
    }

    onFilter(tableConfig: TableConfig) {
        this.getIssues(tableConfig);
    }

    getIssues(tableConfig = this.tableConfig) {
        this._logger.info('getIssues:: Retrieving list of issues');
        this.isLoadingIssues = true;
        this.issuesService.getAllIssues(tableConfig).subscribe(data => {
                this._logger.info('getIssues:: API returned data', data);
                this.issues = data.items;
                this.tableConfig.pager.count = data.count;
                this.isLoadingIssues = false;
            },
            (error: any) => {
                this.isLoadingIssues = false;
                this._logger.error('getIssues:: API returned error', error);
            });
    }

    getReasons() {
        this._logger.info('getReasons:: Retrieving list of reasons');
        this.isLoadingRoles = true;
        this.reasonsService.getAllIReasons().subscribe(data => {
                this._logger.info('getReasons:: API returned data', data);
                this.reasons = data.items;
                this.isLoadingRoles = false;
            },
            (error: any) => {
                this.isLoadingRoles = false;
                this._logger.error('getReasons:: API returned error', error);
            });
    }

    onSortChange(tableState) {
        this.getIssues(tableState);
    }

    onTableRowClick(issue: Issue) {
        this.issueModal.open(issue);
    }

    onPageChange(tableConfig: TableConfig) {
        this.getIssues(tableConfig);
    }

    shouldRenderModifiers() {
        return this.permissionService.hasHasPermissionForFeature('VIEW_REASONS');
    }

    onDownloadIssuesReport(tableConfig = this.tableConfig) {
        this.issuesService.downloadIssuesReport(tableConfig).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    this._logger.info('onDownloadIssueReport:: API Returned error', data);
                    const blob = new Blob([data.body], {type: 'application/xsls'});
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
            },
            (error: any) => {
                this._logger.error('onDownloadIssueReport:: API Returned error', error);
            }
        );
    }
}
